import { createFileRoute } from "@tanstack/react-router";

import { AgenciesPage } from "@/features/agencies/components/agencies-page";

export const Route = createFileRoute("/_authed/_dashboard/agencies/")({
  component: AgenciesPage,
});
